export enum InstatusPageStatus {
  UP = "UP",
  HASISSUES = "HASISSUES",
  UNDERMAINTENANCE = "UNDERMAINTENANCE",
}

export enum InstatusIncidentStatus {
  INVESTIGATING = "INVESTIGATING",
  IDENTIFIED = "IDENTIFIED",
  MONITORING = "MONITORING",
  RESOLVED = "RESOLVED",
}

export enum InstatusIncidentImpact {
  OPERATIONAL = "OPERATIONAL",
  PARTIALOUTAGE = "PARTIALOUTAGE",
  MINOROUTAGE = "MINOROUTAGE",
  MAJOROUTAGE = "MAJOROUTAGE",
}

export enum InstatusMaintenanceStatus {
  NOTSTARTEDYET = "NOTSTARTEDYET",
  INPROGRESS = "INPROGRESS",
  COMPLETED = "COMPLETED",
}

export interface InstatusResponse {
  page: InstatusPage;
  activeIncidents?: InstatusActiveIncident[];
  activeMaintenances?: InstatusActiveMaintenance[];
}

export interface InstatusPage {
  name: string;
  url: string;
  status: InstatusPageStatus;
}

export interface InstatusActiveIncident {
  [key: string]: unknown;
  id: string;
  name: string;
  started: string;
  updated_at: string;
  status: InstatusIncidentStatus;
  impact: InstatusIncidentImpact;
  url: string;
}

export interface InstatusActiveMaintenance {
  [key: string]: unknown;
  id: string;
  name: string;
  start: string;
  updated_at: string;
  status: InstatusMaintenanceStatus;
  duration: number; // in minutes
  url: string;
}
